import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const useSignUpNationality = () => {
  const { retailer } = useRetailer();
  const isAmerican = retailer?.country === ISO3166Alpha3.USA;

  return {
    isAmerican,
  };
};
